import React, { FunctionComponent } from 'react'
import { Grid, Text } from '@afterpaytouch/core'
import { Trans } from 'next-i18next'
import { useSignUpTerms } from './hooks'

export const Disclaimer: FunctionComponent = () => {
  const signUpTerms = useSignUpTerms()

  return (
    <Grid>
      <Text color='Gray40' size='XXS'>
        <Trans i18nKey='signUp:terms' components={signUpTerms} />
      </Text>
    </Grid>
  )
}
